import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { CookiesProvider } from "react-cookie";
import { ConfigProvider } from "antd";
import config from "./config.json";

import App from "./App/index";
import * as serviceWorker from "./serviceWorker";

// Importing Store Module
import { store } from "./config/Store";
import "antd/dist/antd.css";

// Support RTL
import { createMuiTheme } from "@material-ui/core/styles";
import { StylesProvider, ThemeProvider, jssPreset } from "@material-ui/styles";
import { create } from "jss";
import rtl from "jss-rtl";

const jss = create({ plugins: [...jssPreset().plugins, rtl()] });

const defaultTheme = createMuiTheme({
  direction: "rtl",
  typography: {
    fontSize: 12,
    fontFamily: "IranYekan, Roboto",
  },
  palette: {
    primary: {
      light: "red",
      main: "#3F51B5",
      dark: "#3848a2",
      contrastText: "#fff",
    },
    secondary: {
      light: "#ff7961",
      main: "#f44336",
      dark: "#ba000d",
      contrastText: "#000",
    },
  },
  overrides: {
    MuiFormControl: {
      root: {
        width: "100%",
      },
    },
    MuiFilledInput: {
      root: {
        width: "100%",
      },
    },
    MuiPaginationItem: {
      root: {
        "font-family": "Roboto",
      },
    },
    MuiTooltip: {
      tooltip: {
        fontSize: "13px",
      },
    },
  },
});

let theme = defaultTheme;

if (config.COLOR && config.COLOR === "secondary") {
  const palette = {
    primary: {
      light: "#00adff",
      main: "#006bff",
      dark: "#004fbd",
      contrastText: "#fff",
    },
    secondary: {
      light: "#ff7961",
      main: "#f44336",
      dark: "#ba000d",
      contrastText: "#000",
    },
  };

  theme = createMuiTheme({
    ...defaultTheme,
    palette: {
      ...palette,
    },
  });
}

const app = (
  <Provider store={store}>
    <BrowserRouter>
      <CookiesProvider>
        <StylesProvider jss={jss}>
          <ConfigProvider direction="rtl">
            <ThemeProvider theme={theme}>
              <App />
            </ThemeProvider>
          </ConfigProvider>
        </StylesProvider>
      </CookiesProvider>
    </BrowserRouter>
  </Provider>
);

ReactDOM.createRoot(document.getElementById("root")).render(app);
serviceWorker.unregister();
